import React from 'react';
import { 
  BonusDrawContainer, 
  BonusDrawContent, 
  BonusDrawHeader, 
  BonusDrawImage, 
  BonusDrawInfo, 
  BonusDrawMedia, 
  BonusDrawbadge, 
  Button, 
  SubtitleText, 
  TitleText 
} from 'raffle-house-uikit';
import "./style.scss";

export default function BonusDraw({onCTAClick}) { 
  return (
    <BonusDrawContainer>
        <BonusDrawHeader>
          <TitleText isCentered as='h2' variant={"primary"} color='color-1'>
            The Porsche Bonus Draw
          </TitleText>
          <SubtitleText color='color-1' isCentered>
            Buy a ticket to win the Surrey Dream Home before midnight September 30 & also be entered to win the Porsche Bonus Draw
          </SubtitleText>
        </BonusDrawHeader>
        <BonusDrawContent>
          <BonusDrawInfo>
            <TitleText isCentered as='h3' variant={"primary"} color='color-2'>
              Win this Porsche Cayman 718 worth £65,000
            </TitleText>
            <Button onClick={onCTAClick}>Enter now</Button>
          </BonusDrawInfo>
          <BonusDrawMedia>
            <BonusDrawImage srcSet={`
              ${process.env.REACT_APP_AWS_S3_URL + "bonus-draw/gallery/features_800x600.jpg"} 800w,
              ${process.env.REACT_APP_AWS_S3_URL + "bonus-draw/gallery/features_1600x900.jpg"} 1600w,
              ${process.env.REACT_APP_AWS_S3_URL + "bonus-draw/gallery/features_2048x1536.jpg"} 2048w,
              ${process.env.REACT_APP_AWS_S3_URL + "bonus-draw/gallery/features_3840x2160.jpg"} 3840w,
            `} sizes={`(max-width: 800px) 800px, (max-width: 1600px) 1600px, (max-width: 2048px) 2048px, 3840px`} src={process.env.REACT_APP_AWS_S3_URL + "bonus-draw/gallery/features_1600x900.jpg"} alt='property' />
            <BonusDrawbadge />
          </BonusDrawMedia>
        </BonusDrawContent>
      </BonusDrawContainer>
  )
}
